import { memo } from 'react';

import templates from '../templates';
import ValuePaneDefault from './ValuePaneDefault';

type TProps = {
  deck: TDeck;
  word: TWord;
  disabled: boolean;
  finished: boolean;
};

const ValuePane: React.FC<TProps> = ({ deck, word, disabled, finished }) => {
  if (deck.templateType !== TDeckTemplate.default) {
    const Pane = templates[deck.templateType].ValuePane;
    return <Pane word={word} disabled={disabled} finished={finished} />;
  }

  return (
    <ValuePaneDefault
      word={word}
      deck={deck}
      disabled={disabled}
      finished={finished}
    />
  );
};

export default memo(ValuePane);
